import { Injectable } from '@angular/core';
import { Jurisdiction } from '../../domain';
import { Subject } from 'rxjs';

@Injectable()
export class JurisdictionService {

  private selectedJurisdictionSource = new Subject<Jurisdiction>();

  selectedJurisdiction = this.selectedJurisdictionSource.asObservable();

  announceSelectedJurisdiction(jurisdiction: Jurisdiction) {
    this.selectedJurisdictionSource.next(jurisdiction);
  }

}
